import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-24 text-center"
      data-testid="not-found-page"
    >
      <Compass size={36} strokeWidth={1.5} className="text-text-muted" />
      <h1 className="font-heading text-xl font-semibold text-text-main">Page not found</h1>
      <p className="max-w-sm text-sm text-text-muted">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Button asChild size="sm" data-testid="not-found-back-link">
        <Link to="/">Back to Dashboard</Link>
      </Button>
    </div>
  );
}
